import { BaSeTag, BaSeTheme } from '@base/react';
import React from 'react';

export const StatusCertificado = (values) => {
  const tags = {
    type: 'primary',
    themeMode: 'light',
    isSelected: true,
    size: 'medium',
  };

  switch (values?.situacaoChave) {
    case 'NAO_PROCESSADO':
      return (
        <BaSeTag
          color={BaSeTheme.colors.feedbackInterface.atencao55}
          label={values?.situacao}
          {...tags}
        />
      );
    case 'ENVIADO_PARA_FILA':
      return (
        <BaSeTag
          color={BaSeTheme.colors.feedbackInterface.atencao55}
          label={values?.situacao}
        />
      );
    case 'REPROCESSANDO':
      return <BaSeTag color="default" label={values?.situacao} {...tags} />;
    case 'PROCESSANDO':
      return (
        <BaSeTag
          color={BaSeTheme.colors.feedbackInterface.informacao}
          label={values?.situacao}
        />
      );
    case 'GERADO':
      return (
        <BaSeTag
          color={BaSeTheme.colors.feedbackInterface.sucesso20}
          label={values?.situacao}
        />
      );
    case 'ERRO':
      return (
        <BaSeTag
          color={BaSeTheme.colors.feedbackInterface.erro35}
          label={values?.situacao}
        />
      );
    default:
      return;
  }
};
